import React, { useEffect, useState } from 'react';
import {
    Box,
    Card,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    IconButton,
    Tooltip,
    CircularProgress,
    TablePagination
} from '@mui/material';
import MapIcon from '@mui/icons-material/Map';
import PndApi from 'src/utils/pnd/PndRestApi';
import RiderLocationMapModal from 'src/containers/PnD/RiderLocationHistory/View/components/RiderLocationMapModal';
import { formatDate } from 'src/utils/DateUtils';

const RiderLatestLocationGrid = ({ selectedHubId }) => {
    const [locations, setLocations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    // modal states
    const [mapModalShow, setMapModalShow] = useState(false);
    const [mapData, setMapData] = useState(null);

    useEffect(() => {
        fetchLocations();
        const interval = setInterval(fetchLocations, 60000);
        return () => clearInterval(interval);
    }, [selectedHubId]);

    const fetchLocations = async () => {
        try {
            setLoading(true);
            const response = await PndApi.FindRiderLiveGridViewData(selectedHubId);
            if (response.status === 200 && response.data.status === 200) {
                const payload = response.data.data;
                if (Array.isArray(payload)) setLocations(payload);
                else if (payload && Array.isArray(payload.tableRowsData)) setLocations(payload.tableRowsData);
                else setLocations([]);
            } else {
                setLocations([]);
            }
        } catch (error) {
            console.error('Error fetching rider locations:', error);
            setLocations([]);
        } finally {
            setLoading(false);
        }
    };

    const handleOpenMap = (rider) => {
        setMapData(rider);
        setMapModalShow(true);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    if (loading && locations.length === 0) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                <CircularProgress sx={{ color: '#32CA73' }} />
            </Box>
        );
    }

    const paginatedLocations = locations.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
        <Box sx={{ width: '100%' }}>
            <TableContainer component={Card} sx={{ boxShadow: 'none', borderRadius: 1, border: '1px solid #e2e8f0' }}>
                <Table size="small">
                    <TableHead sx={{ backgroundColor: '#f8fafc' }}>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 'bold', fontSize: '12px', py: 1 }}>RIDER</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', fontSize: '12px', py: 1 }}>PLATE NO</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', fontSize: '12px', py: 1 }}>VEHICLE</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', fontSize: '12px', py: 1 }} align="center">SPEED (KM/H)</TableCell>
                            {/* <TableCell sx={{ fontWeight: 'bold', fontSize: '12px', py: 1 }}>LAST UPDATED</TableCell> */}
                            <TableCell align="center" sx={{ fontWeight: 'bold', fontSize: '12px', py: 1 }}>Location</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {paginatedLocations.length > 0 ? paginatedLocations.map((rider, index) => (
                            <TableRow key={index} sx={{ '&:hover': { backgroundColor: '#f1f5f9' } }}>
                                <TableCell sx={{ py: 0.5 }}>
                                    <Typography variant="body2" sx={{ fontWeight: 'bold', fontSize: '12px' }}>{rider.riderName || 'N/A'}</Typography>
                                    <Typography variant="caption" sx={{ color: '#94a3b8', fontSize: '10px' }}>{rider.riderUserName || 'N/A'}</Typography>
                                </TableCell>
                                <TableCell sx={{ fontSize: '12px', py: 0.5 }}>{rider.plateNo || 'N/A'}</TableCell>
                                <TableCell sx={{ fontSize: '12px', py: 0.5 }}>{rider.vehicleMode || 'N/A'}</TableCell>
                                <TableCell align="center" sx={{ fontSize: '12px', py: 0.5, fontWeight: 'bold', color: rider.speed > 0 ? '#10b981' : '#64748b' }}>
                                    {rider.speed || 0}
                                </TableCell>
                                {/* <TableCell sx={{ fontSize: '12px', py: 0.5 }}>
                                    {rider.lastUpdateDatetime ? formatDate(rider.lastUpdateDatetime) : 'N/A'}
                                </TableCell> */}
                                <TableCell align="center" sx={{ py: 0.5 }}>
                                 { rider?. location}
                                </TableCell>
                            </TableRow>
                        )) : (
                            <TableRow>
                                <TableCell colSpan={6} align="center" sx={{ py: 4, color: '#999' }}>
                                    No location data available
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={locations.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </TableContainer>

            {mapModalShow && (
                <RiderLocationMapModal
                    modalShow={mapModalShow}
                    setModalShow={setMapModalShow}
                    data={mapData}
                />
            )}
        </Box>
    );
};

export default RiderLatestLocationGrid;
